import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARFISH_PETITION_QUALITY_SCORE_TOGGLE = createFcmDetails(
	'starfish_petition_quality_score_toggle',
	{
		owner: 'starfish',
		context: 'Petition Quality Score',
		import: false,
		description:
			'Feature toggle for generating the petition quality score on petition publish and returning it for the starter onboarding page',
		mergeLogic: 'Needs combination of both country code and locale to be enabled',
	},
);
